export var GameState;
(function (GameState) {
    GameState[GameState["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    GameState[GameState["WON"] = 2] = "WON";
    GameState[GameState["LOST"] = 3] = "LOST";
})(GameState || (GameState = {}));
